import { createContext } from 'react';

const PlanManagerContext = createContext();

export default PlanManagerContext;
